module.exports = __webpack_public_path__ + "static/info-apoio-8c7617e58046980c4d8f73b1bcbe7bd6.png";